import { useQuery } from '@tanstack/react-query';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { AdminStore } from 'services/api/admin';
import { queries } from 'services/queries';

// 已失效
export const authInvalidShopsState = atom<AdminStore[]>([]);

export const authInvalidShopMap = atom((get) => {
  const shopList = get(authInvalidShopsState);

  return shopList.reduce<
    Partial<
      Record<
        General.PlatformUpperCaseTunnel,
        Partial<Record<General.UpperCaseRegion, Record<string, AdminStore>>>
      >
    >
  >((res, shop) => {
    const { externalType, region, id } = shop;

    if (!res[externalType]) {
      res[externalType] = {};
    }

    const platformMap = res[externalType] || {};

    if (!platformMap[region]) {
      platformMap[region] = {};
    }

    const regionMap = platformMap[region] || {};

    regionMap[`${id}`] = shop;

    return res;
  }, {});
});

export const useAuthInvalidShopsValue = () => {
  return useAtomValue(authInvalidShopsState);
};

export const useSetAuthInvalidShops = () => {
  return useSetAtom(authInvalidShopsState);
};

export const useAuthInvalidShopMapValue = () => {
  return useAtomValue(authInvalidShopMap);
};

// 即将失效
export const authBeAboutExpireShopsState = atom<AdminStore[]>([]);

export const authBeAboutExpireShopMap = atom((get) => {
  const shopList = get(authBeAboutExpireShopsState);

  return shopList.reduce<
    Partial<
      Record<
        General.PlatformUpperCaseTunnel,
        Partial<Record<General.UpperCaseRegion, Record<string, AdminStore>>>
      >
    >
  >((res, shop) => {
    const { externalType, region, id } = shop;

    if (!res[externalType]) {
      res[externalType] = {};
    }

    const platformMap = res[externalType] || {};

    if (!platformMap[region]) {
      platformMap[region] = {};
    }

    const regionMap = platformMap[region] || {};

    regionMap[`${id}`] = shop;

    return res;
  }, {});
});

export const useAuthBeAboutExpireShopsValue = () => {
  return useAtomValue(authBeAboutExpireShopsState);
};

export const useSetAuthBeAboutExpireShops = () => {
  return useSetAtom(authBeAboutExpireShopsState);
};

export const useAuthBeAboutExpireShopMapValue = () => {
  return useAtomValue(authBeAboutExpireShopMap);
};

export const useAuthInvalidShops = () => {
  const setAuthInvalidShops = useSetAuthInvalidShops();
  const authInvalidShops = useAuthInvalidShopsValue();

  const { data: res } = useQuery({
    ...queries.stores.stores({
      page: 1,
      pageSize: 100000,
      authStatus: 1,
    }),
    refetchInterval: 1000 * 60 * 60,
  });

  useEffect(() => {
    if (res) {
      setAuthInvalidShops(res?.data?.data?.stores ?? []);
    }
  }, [res, setAuthInvalidShops]);

  return {
    authInvalidShops,
  };
};

export const useAuthBeAboutExpireShops = () => {
  const setAuthBeAboutExpireShops = useSetAuthBeAboutExpireShops();
  const authBeAboutExpireShops = useAuthBeAboutExpireShopsValue();

  const { data: res } = useQuery({
    ...queries.stores.stores({
      page: 1,
      pageSize: 100000,
      authStatus: 2,
    }),
    refetchInterval: 1000 * 60 * 60,
  });

  useEffect(() => {
    if (res) {
      setAuthBeAboutExpireShops(res?.data?.data?.stores ?? []);
    }
  }, [res, setAuthBeAboutExpireShops]);

  return {
    authBeAboutExpireShops,
  };
};
